// PolicyPage — shared wrapper for Shipping, Privacy, Terms of Service pages.
// Navy site frame, script-font heading, readable article column. Content
// lives in each policy-page file that imports this.

import SiteNav from "./components/SiteNav";
import SiteFooter from "./sections/SiteFooter";
import PanBar from "./components/PanBar";

export default function PolicyPage({ title, lastUpdated, children }) {
  return (
    <div style={{ background: "#081a2a", minHeight: "100vh", color: "var(--jop-cream)", fontFamily: "var(--jop-display)" }}>
      <SiteNav />
      <main style={{ maxWidth: "760px", margin: "0 auto", padding: "5.5rem 1.5rem 4rem" }}>
        <header style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <PanBar width={80} height={3} margin="0 auto 1.1rem" />
          <h1 style={{
            margin: "0 0 0.5rem",
            fontFamily: "var(--jop-script)",
            fontSize: "clamp(2.2rem, 5.5vw, 3.2rem)",
            color: "var(--jop-gold)",
            fontWeight: 700,
            lineHeight: 1.1,
          }}>
            {title}
          </h1>
          {lastUpdated && (
            <div style={{
              color: "rgba(255,218,173,0.5)",
              fontSize: "0.78rem",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              fontWeight: 600,
            }}>
              Last updated {lastUpdated}
            </div>
          )}
        </header>

        <article style={{
          color: "var(--jop-cream)",
          fontSize: "1rem",
          lineHeight: 1.7,
        }} className="jop-policy-body">
          {children}
        </article>

        <div style={{
          marginTop: "3rem",
          paddingTop: "1.5rem",
          borderTop: "1px solid rgba(255,218,173,0.12)",
          display: "flex",
          gap: "1.5rem",
          flexWrap: "wrap",
          justifyContent: "center",
          fontSize: "0.82rem",
        }}>
          <a href="/shipping" style={policyLink}>Shipping & Returns</a>
          <a href="/privacy"  style={policyLink}>Privacy Policy</a>
          <a href="/terms"    style={policyLink}>Terms of Service</a>
        </div>
      </main>

      <style>{`
        .jop-policy-body h2 {
          font-family: var(--jop-display);
          color: var(--jop-gold);
          font-size: 1.25rem;
          font-weight: 800;
          margin: 2.2rem 0 0.6rem;
          letter-spacing: -0.005em;
        }
        .jop-policy-body h3 {
          font-family: var(--jop-display);
          color: var(--jop-cream);
          font-size: 1.02rem;
          font-weight: 700;
          margin: 1.4rem 0 0.3rem;
        }
        .jop-policy-body p { margin: 0 0 1rem; }
        .jop-policy-body ul { margin: 0 0 1.2rem; padding-left: 1.2rem; }
        .jop-policy-body li { margin-bottom: 0.35rem; }
        .jop-policy-body a {
          color: var(--jop-highlight-blue);
          text-decoration: underline;
          text-decoration-color: rgba(74,164,225,0.4);
          text-underline-offset: 3px;
        }
        .jop-policy-body strong { color: var(--jop-cream); }
        .jop-policy-body .jop-policy-callout {
          background: rgba(252,179,31,0.08);
          border: 1px solid rgba(252,179,31,0.28);
          border-radius: 10px;
          padding: 0.85rem 1rem;
          margin: 1rem 0 1.3rem;
          font-size: 0.94rem;
        }
      `}</style>

      <SiteFooter />
    </div>
  );
}

const policyLink = {
  color: "rgba(255,218,173,0.65)",
  textDecoration: "none",
  fontWeight: 600,
};
